export default __webpack_public_path__ + "static/media/zoomout.c6f8e456.svg";